import React, { useEffect } from 'react';
import useTagList from '../../../review/common/hook/useTagList';
import Panel from '../../../../../components/outline/Panel';
import Button from '../../../../../components/Button';
import TableTransfer from '../../../../../components/input/TableTransfer';
import ExcelUploadForm from '../../../../../components/form/ExcelUploadForm';
import Anchor from '../../../../../components/link/Anchor';
import { columns } from './columns';
import './CsReviewTagInfo.scss';
import { TAG_UPLOAD_TEMPLATE_XLSX_URL } from '../../../../../constants/service/common/staticFileUrlConstants';

const CsReviewTagInfo = (props) => {
  const { productId, value, onChange } = props;
  const {
    onChangeSelectedTagList,
    onClickAllTagListExcelDownload,
    onClickSelectedTagListExcelDownload,
    onChangeTableOptions,
    onClickRelatedTagList,
    onClickTagExcelUpload,
    onClickProductTagList,
    tagList,
    tableOptions,
    selectedTagList,
    setSelectedTagList,
  } = useTagList();

  useEffect(() => {
    if (!value) return;
    setSelectedTagList(value);
  }, [value]);

  return (
    <Panel className="cs-review-tag-info">
      <div className="panel-header">
        <div className="title">후기 태그 정보</div>
        {productId && (
          <Button
            isRadius
            color="primary"
            text="상품 태그 가져오기"
            onClick={(e) => {
              e.preventDefault();
              onClickProductTagList(productId);
            }}
          />
        )}
      </div>

      <div className="panel-body">
        <TableTransfer
          dataSource={tagList?.tags}
          operations={['연결', '해제']}
          leftTitle="태그 리스트"
          rightTitle="연결된 태그 리스트"
          leftTableProps={{
            columns: (utils) =>
              columns({
                ...utils,
                onClickRelatedTagList,
                isFilter: true,
              }),
            headInfo: (
              <div className="review-detail-tag-head right">
                <Button isRadius color="light" text="엑셀 다운로드" onClick={onClickAllTagListExcelDownload} />
              </div>
            ),
            rowClassName: (record) => (record.uncheckable ? 'uncheckable' : null),
            getList: (option) => onChangeTableOptions(option),
            pagination: {
              pageNum: tableOptions.page,
              pageSize: tableOptions.pageSize,
              totalCnt: tagList?.totalCount,
            },
            sortOption: {
              id: tableOptions.sort.id,
            },
            filterOption: {
              name: tableOptions.name,
              id: tableOptions.id,
            },
          }}
          rightTableProps={{
            columns: (utils) =>
              columns({
                ...utils,
                onClickRelatedTagList,
              }),
            headInfo: (
              <div className="review-detail-tag-head">
                <div className="selected-review-tag-item-count">
                  선택된 아이템 개수 <span>{selectedTagList.length}</span>
                </div>
                <div className="excel-button-list">
                  <Anchor
                    text="태그 업로드 템플릿"
                    isUnderLine
                    color="primary"
                    href={TAG_UPLOAD_TEMPLATE_XLSX_URL}
                    target="_blank"
                  />
                  <Button isRadius color="light" text="엑셀 다운로드" onClick={onClickSelectedTagListExcelDownload} />
                  <ExcelUploadForm onChange={onClickTagExcelUpload} btnText="태그 엑셀 업로드" />
                </div>
              </div>
            ),
            list: selectedTagList,
          }}
          onChange={(action, moveIdList) => {
            onChangeSelectedTagList(action, moveIdList);
            if (action === 'add') {
              onChange([...value, ...(tagList?.tags.filter((tag) => moveIdList.includes(tag.id)) ?? [])]);
            } else {
              onChange(selectedTagList.filter((tag) => !moveIdList.includes(tag.id)));
            }
          }}
        />
      </div>
    </Panel>
  );
};

export default CsReviewTagInfo;
